export const SHORTLIST_STORAGE_KEY = 'shortlist';
export const SHORTLIST_PERSISTED_VERSION = 1;
export const MAX_SHORTLIST_SIZE = 9;
export const MAX_PREVIEW_AVATARS = 3;
/** Avatar cap for the mWeb floating pill; the label still shows the real count. */
export const MAX_PILL_AVATARS = 3;
/** The contact list suggests sitters until this many can be contacted. */
export const RECOMMENDED_CONTACT_COUNT = 3;

export const MULTI_CONTACT_ROUTE = '/multi-contact-sitter/';

/**
 * DOM mount node (in the Django header) for ShortListModal.
 */
export const SHORTLIST_MODAL_SELECTOR = '#react-shortlist-modal';

/**
 * Window event dispatched by the non-React navbar button to open the modal.
 * Bridges legacy (Django/Backbone) pages to ShortListModal.
 */
export const SHORTLIST_MODAL_OPEN_EVENT = 'rover:shortlist:open';

/**
 * Window event dispatched after the persisted shortlist changes in this tab.
 * The `storage` event only fires in other tabs, so non-React listeners (the
 * Django navbar badge) need this to stay in sync with same-tab mutations.
 */
export const SHORTLIST_CHANGE_EVENT = 'rover:shortlist:change';
